import React, { useMemo } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { Box, Button, Typography } from "@mui/material";

import RowActions from "./RowActions";
import { addUser, updateUser } from "../../ManageUsers/api";

export default function ExpandableTable({
  data,
  setData,
  entityName,
  cols,
  subSection,
  tableTitle,
  expand = true,
  addNewBtn = false,
}) {
  const columns = cols;

  const onUpdateUser = async (row, values) => {
    const data = await updateUser(row.id, values);
    console.log("inactivate res: ", data);

    setData((prev) =>
      prev.map((r) => {
        if (r.id === row.id) return { ...data };
        return r;
      })
    );
  };
  const onInactivate = async (row) => {
    await onUpdateUser(row, { status: "inactivated" });
  };

  const onActivate = async (row) => {
    await onUpdateUser(row, { status: "active" });
  };

  const renderDetailPanel = expand
    ? { renderDetailPanel: ({ row }) => subSection(row.original) }
    : {};
  const table = useMaterialReactTable({
    columns: [
      {
        header: "#",
        accessorFn: (row, rowIndex) => rowIndex + 1,
        size: 10,
        enableSorting: false,
        enableEditing: false,
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        Edit: () => <></>,
      },
      ...columns,
    ],
    data,

    enableColumnActions: false,
    enableEditing: true,
    enableSorting: false,
    editingMode: "modal",
    // editDisplayMode: "row",

    muiTableHeadCellProps: {
      sx: {
        border: "0.5px solid rgba(81, 81, 81, .1)",
        // fontStyle: 'italic',
        fontWeight: "normal",
        padding: "10px",
        backgroundColor: "var(--pv-table-header-bg)",
      },
    },
    muiTableBodyCellProps: {
      sx: {
        border: "1px solid rgba(81, 81, 81, .1)",
        padding: "10px",
      },
    },
    // CREATE
    onCreatingRowSave: async ({ values, table }) => {
      const fixedValues = {
        ...values,
        password: values.initialPassword,
        roles: Array.isArray(values.roles)
          ? values.roles
          : values.roles
          ? [values.roles]
          : [],
      };
      console.log("SAVED:", fixedValues);

      const res = await addUser(fixedValues);
      if (res?.[0]) {
        setData((prev) => [...prev, { id: Date.now(), ...fixedValues }]);
      }

      table.setCreatingRow(null);
    },

    // UPDATE
    onEditingRowSave: async ({ values, row, table }) => {
      setData((prev) =>
        prev.map((r) =>
          r.id === row.original.id ? { ...row.original, ...values } : r
        )
      );
      table.setEditingRow(null);
    },

    // Row actions (edit/delete)
    renderRowActions: ({ row, table }) => (
      <RowActions
        row={row.original}
        table={table}
        onActivate={onActivate}
        onInactivate={onInactivate}
      />
    ),
    positionActionsColumn: "last",
    // Toolbar actions
    renderTopToolbarCustomActions: ({ table }) =>
      addNewBtn ? (
        <Button variant="contained" onClick={() => table.setCreatingRow(true)}>
          Add New {entityName}
        </Button>
      ) : (
        <Box />
      ),

    /// expansion
    enableExpanding: expand,
    ...renderDetailPanel,
  });
  return (
    <Box p={3} sx={{ backgroundColor: "var(--app-surface)", borderRadius: 2, boxShadow: 1 }}>
      {tableTitle && (
        <Typography variant="h5" gutterBottom fontWeight={600}>
          {tableTitle}
        </Typography>
      )}

      <MaterialReactTable table={table} />
    </Box>
  );
}
